import { PagedResponse, RequestResponse } from '@core/services/request/model/request.model';
import {
  MyServicesListingFilterApi,
  MyServicesListingInstallationApi,
  MyServicesListingSocietyApi,
} from '@core/api/model/my-services/my-services-listing-api.model';
import {
  MyServicesListingFilter,
  MyServicesListingInstallation,
  MyServicesListingSociety,
} from '@core/domain/model/services/my-services-listing.model';
import { acJoin } from '@shared/pipes/join/join.pipe';
import { sortDomainToApi } from '@shared/components/table/sort/model/sort.model';
import { pagingDomainToApi } from '@shared/components/paginator/models/paginator-input.model';
import { TagElement } from '@core/domain/mappers/assistants/tags.directory';
import { TagTransformer } from '@core/domain/mappers/assistants/tag.transformer';

export class MyServicesListingMapper {
  public static servicesFilterFromDomainToApi(input: MyServicesListingFilter): MyServicesListingFilterApi {
    const sort = sortDomainToApi(input);
    const paging = pagingDomainToApi(input);
    return {
      ...sort,
      ...paging,
      filterCodSociedades: input.societies,
      filterCodInstalaciones: input.installations,
      filterProxVencimientos: input.closeDueDate,
    };
  }

  public static societyRequestFromApiToDomain(
    input: RequestResponse<PagedResponse<MyServicesListingSocietyApi>>
  ): RequestResponse<PagedResponse<MyServicesListingSociety>> {
    return {
      ...input,
      data: {
        ...input.data,
        values: input.data.values.map(MyServicesListingMapper.societyItemFromApiToDomain),
      },
    };
  }

  public static societyItemFromApiToDomain(input: MyServicesListingSocietyApi): MyServicesListingSociety {
    return {
      id: input.codigoCRM,
      cif: input.cif,
      volume: input.volumenConsumido,
      contractsNo: input.numContratos,
      name: input.nombreRazonSocial,
      completeName: acJoin([input.nombreRazonSocial, input.cif], ' | ').toUpperCase(),
      installations: input.instalaciones.map(MyServicesListingMapper.installationItemFromApiToDomain),
    };
  }

  public static installationItemFromApiToDomain(input: MyServicesListingInstallationApi): MyServicesListingInstallation {
    return {
      id: input.codigoCRM,
      cups: input.cup,
      name: input.nombreInstalacion,
      completeName: acJoin([input.nombreInstalacion, input.cup], ' | '),
      volume: input.volumenConsumido,
      contractEndDate: input.fechaFinContrato,
      contractStartDate: input.fechaInicioContrato,
      contractStatus: input.estadoContrato,
      contractStatusId: input.estadoContratoCodigo,
      contractStatusTag: TagTransformer.tagTypeFromCode(input.estadoContratoCodigo, TagElement.INSTALLATION),
      sepaDCTMId: input.idDctmSepa,
      contractDCTMId: input.idDctmContrato,
    };
  }
}
